import { useMediaQuery } from "react-responsive";
import StoreLocatorForm from "./common/LocatorForm";
import NavBar from "./common/NavBar";
import Header from "./common/Header";
import Footer from "./common/Footer";
import FooterMinified from "./common/FooterMinified";

const StudioLocator = () => {
  const isDesktop = useMediaQuery({ minDeviceWidth: 821 });
  return (
    <div>
      {isDesktop ? (
        <NavBar isWhiteImage={false} textColor={"black"}></NavBar>
      ) : (
        <Header
          isWhiteImage={false}
          textColor={"black"}
          bgColor="white"
        ></Header>
      )}
      <StoreLocatorForm></StoreLocatorForm>
      {isDesktop ? <Footer></Footer> : <FooterMinified></FooterMinified>}
    </div>
  );
};

export default StudioLocator;
